(function($) {

  //console.log('ready !');

  function centerVideo() {

    if ( $( '#bgvid' ).length ) {

      //console.log('video exists');

      video_container_height = $('.video-container').innerHeight();
      video_container_width = $('.video-container').innerWidth();
      video_height = $('#bgvid').innerHeight();
      video_width = $('#bgvid').innerWidth();
      video_y_offset = (video_height - video_container_height)/2;
      video_x_offset = (video_width - video_container_width)/2;
      body_y_offset = $('body').offset().top;

      //console.log('video_container_height='+video_container_height);
      //console.log('video_height='+video_height);
      //console.log('video_y_offset='+video_y_offset);
      //console.log('video_x_offset='+video_x_offset);
      //console.log('body_y_offset='+body_y_offset);

      if(video_y_offset > 0) {
        $('#bgvid').css('margin-top', -video_y_offset);
      }
      
      if(video_x_offset > 0) {
        $('#bgvid').css('margin-left', -video_x_offset);
      }

      if(body_y_offset > 0) {
        $('.video-trame').css('margin-top', body_y_offset);
        $('.video-infos').css('margin-top', body_y_offset);
      }   

      // opacity fade
      $('#bgvid').css('opacity', 1);
      $('.video-trame').css('opacity', 0.6);

    }

  }
  centerVideo();
  $(window).on("load resize", centerVideo);

})(jQuery);